import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-suggestions',
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss'],
  providers: [AuthService]
})
export class SuggestionsComponent implements OnInit {

  panelOpenState: boolean = false;

  constructor(private _authService: AuthService, private router: Router) { }

  ngOnInit() {
  }

}
